<template>
  <div class="sprodetailApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide">
        <a href=""><img src="https://ss0.baidu.com/6ONWsjip0QIZ8tyhnq/it/u=49257564,1524929021&fm=199&app=68&f=JPEG?w=420&h=420&s=1C924A97CAFBF6CE5A0A4AAE0300A00F"></a>
      </swiper-slide>
    </swiper>

    <div class="title">
      <h2>最甜火龙果五斤装（红心包邮）</h2>
      <p>
        <font>月售：36</font>
      </p>
      <div class="price">
        <i><b>¥</b> 18.<b>00</b></i>
        <span>38.00</span>
      </div>
    </div>


    <div class="content">
      <div class="desc">
        木兰火龙果，是一种低热量、富含水溶性膳食纤维、植物性白蛋白及花青素的亚热带水果，不仅可以有效的起到预防以及减肥的作用，能有效防止血管硬化，还具有非常有效的润肺、抗氧化、抗衰老、养颜护胃等功效
        <img src="https://t10.baidu.com/it/u=946594607,283120118&fm=199&app=68&f=JPEG?w=750&h=750&s=F50CFD13C2617EAC282646E10300702C">
      </div>

      <div style="height:65px"></div>
    </div>
    <div class="footers">
      <span>1件商品</span>
      <a>立即购买</a>
      <div class="price">
        <i><b>¥</b> 18.<b>00</b></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },

        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        bg:require('../../assets/images/farm.png'),
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .sprodetailApp{
    background:#fff;
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }
  .sprodetailApp .swiper-slide{
    width:100%
  }
  .sprodetailApp .swiper-slide img{
    display:block;
    width:100%;
  }

  .sprodetailApp .title{
    display:block;
    width:100%;
    background:rgba(255,255,255,0.8);
    padding-bottom:15px
  }
  .sprodetailApp .title h2{
    display:block;
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding-top:15px;
    letter-spacing: 1px
  }
  .sprodetailApp .title p{
    display:block;
    width:94%;
    margin:0 auto;
    font-size:15px;
    padding-top:10px
  }
  .sprodetailApp .title p font{
    color:#666;
  }
  .sprodetailApp .title .price{
    display:block;
    width:94%;
    padding-top:15px;
    margin:0 auto
  }
  .sprodetailApp .title .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }

  .sprodetailApp .title .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .sprodetailApp .title .price b{
    font-size:12px;
  }

  .sprodetailApp .content{
    width: 100%;
    background:rgba(255,255,255,0.8);
    display:block;
    min-height:500px;
    margin-top:10px
  }

  .sprodetailApp .content .desc{
    font-size:15px;
    color:#333;
    width:92%;
    margin:0 auto;
    letter-spacing: 1px;
    line-height:22px;
    padding-top:15px
  }
  .sprodetailApp .content .desc img{
    display:block;
    width:100%;
    margin:5px 0
  }


  .sprodetailApp .footers{
    position:fixed;
    bottom:0;
    width:100%;
    left:0;
    height:49px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    z-index:99
  }
  .sprodetailApp .footers span{
    float:left;
    height:49px;
    line-height:49px;
    margin-left:15px;
    color:#ccc;
    font-size:15px;
  }
  .sprodetailApp .footers a{
    height: 30px;
    background: #FF7F00;
    border-radius: 30px;
    color:#fff;
    width:90px;
    text-align:center;
    line-height: 30px;
    font-size:15px;
    margin-top:9.5px;
    float:right;
    margin-right:15px
  }
  .sprodetailApp .footers .price{
    float:right;
    height:49px;
    line-height:49px;
    margin-right:10px
  }
  .sprodetailApp .footers .price i{
    color: #FF1E00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .sprodetailApp .footers .price b{
    font-size:12px;
  }
</style>